import { render } from "./RicercaCom.vue?vue&type=template&id=ccb1b372"
import script from "./RicercaCom.vue?vue&type=script&lang=js"
export * from "./RicercaCom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__